import React from "react";
import ContentHeader from "../../components/ContentHeader";

const NotFound: React.FC = () => {
	return (
		<div className="wrapperApp">
			<ContentHeader
				title="404 - Not Found"
				breadcrumb={["404"]}
			/>
			<div id="content">
				<section className="content__block">
					<div className="content__header">
						<h2 className="content__title">The page you request was not found</h2>
					</div>
				</section>
			</div>
		</div>
	);
};
export default NotFound;